'use strict';

const moveElements = {
	el: {
		pHeadSlider: document.querySelector('.pHead_slider'),
		bSlider: document.querySelector('.bSlider'),
        blockToMove: document.querySelector('.moveBlockOnMobile'),
		finalPlace: document.querySelector('.newPlace'),
	},
	init() {
        // change element position on mobile devices (for mobile devices only)
        // don't ask me why, ask the client ^^
        if(window.matchMedia("(max-width: 767px)").matches) {
            moveElements.pHeadSlider();
            moveElements.bSlider();
            moveElements.blockToMove();
        }
	},
	pHeadSlider() {
		// let parent = document.querySelector('.bCard_wrap');
        let slider = moveElements.el.pHeadSlider;
        let finalPlace = moveElements.el.finalPlace;
        if(slider && finalPlace) {
            finalPlace.append(slider);
        }
	},
	bSlider() {
		// let parent = document.querySelector('.bCard_wrap');
        let slider = moveElements.el.bSlider;
        let finalPlace = moveElements.el.finalPlace;
        if(slider && finalPlace) {
            finalPlace.append(slider);
        }
    },
    blockToMove() {
		// let parent = document.querySelector('.bCard_wrap');
        let blockToMove = moveElements.el.blockToMove;
        let finalPlace = moveElements.el.finalPlace;
        if(blockToMove && finalPlace) {
            finalPlace.append(blockToMove);
        }
	},
}

export default moveElements;


// WEBPACK FOOTER //
// ./src/scripts/general/moveElements.js